/** Keys available for use with localStorage, in the app */
export enum LSKey {
  BUSINESS_PROFILE_TEMP = 'business-profile-temp',
  PROFILE_IMAGE_PROGRESS = 'profile-image-progress',
  SCAN_WINDOW_OFFSETS = 'scan-window-offsets',
  VIDEO_DIMENSIONS_SWAPPED = 'video-dimensions-swapped',
  LOGIN_OBJ = 'login-obj',
  OLD_API_TOKEN = 'old-auth-token',
  INSTRUCTIONS_STATUS = 'instructions-status',
  AUTO_ADDED_DEVICE = 'auto-added-device',
  WELCOME_DRAWER = 'welcome-drawer',
  REDUX_PERSIST_STORE = 'persist:root',
  REF_CODE = 'ref-code',
  APP_UPDATED = 'app-updated',
  WELCOMED = 'welcomed',
  DEV_TESTING_MODE = 'dev-testing-mode',
}
